<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="align-self-center pl-3 mr-auto">
        <div class="d-flex flex-column">
          <div class="titre-h3 secondary--text ">
            Indicateurs non chiffrés
          </div>
          <div class="titre-h5 secondary--text ">
            <span class="secondary--text align-self-center ">{{ indicateursNonChiffres.typeCulture.nom }}</span>
          </div>
        </div>
      </div>
      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-3 mx-4">
      <v-card
        class="pa-2 mb-2 background"
      >
        <div class="d-flex justify-space-between">
          <div class="secondary--text titre-h5">
            Restitution nutritive
          </div>
          <div class="d-flex justify-space-around">
            <AgrButton
              icon
              @click="onOpenUpdateParametreModal('Restitution nutritive')"
            >
              <v-icon color="grey darken-2">
                mdi-pencil-outline
              </v-icon>
            </AgrButton>
          </div>
        </div>
        <div class="d-flex justify-space-between pr-2">
          <v-spacer />
          <div
            class="align-self-center texte py-0 secondary--text"
          >
            {{ indicateursNonChiffresRestitutionNutritive.apportAzote ? indicateursNonChiffresRestitutionNutritive.apportAzote : '-' }}uN, {{ indicateursNonChiffresRestitutionNutritive.apportPhosphore ? indicateursNonChiffresRestitutionNutritive.apportPhosphore : '-' }}uP, {{ indicateursNonChiffresRestitutionNutritive.apportPotassium ? indicateursNonChiffresRestitutionNutritive.apportPotassium : '-' }}uK
          </div>
        </div>
      </v-card>
      <v-card
        class="pa-2 mb-2 background"
      >
        <div class="d-flex justify-space-between">
          <div class="secondary--text titre-h5">
            PAC (éco-régime)
            <v-chip
              small
              color="secondary"
            >
              <span class="text-lowercase">
                obligatoire
              </span>
            </v-chip>
          </div>
          <div class="d-flex justify-space-around">
            <AgrButton
              icon
              @click="onOpenUpdateParametreModal('PAC')"
            >
              <v-icon color="grey darken-2">
                mdi-pencil-outline
              </v-icon>
            </AgrButton>
          </div>
        </div>
        <div class="d-flex justify-space-between pr-2">
          <v-spacer />
          <div
            class="align-self-center texte py-0 secondary--text"
          >
            {{ indicateursNonChiffresPAC.nombrePointsPAC >= 0 ? indicateursNonChiffresPAC.nombrePointsPAC : '-' }} {{ indicateursNonChiffresPAC.nombrePointsPAC != null ? indicateursNonChiffresPAC.nombrePointsPAC > 1 ? 'points' : 'point' : '' }} {{ indicateursNonChiffresPAC.libellePAC ? '('+indicateursNonChiffresPAC.libellePAC +')' : '' }}
          </div>
        </div>
      </v-card>
      <div class="d-flex justify-space-around my-4">
        <AgrButton
          class="pa-5"
          outlined
          block
          @click="onClose()"
        >
          Fermer
        </AgrButton>
      </div>
      <v-dialog
        v-if="isUpdatePacModalOpen"
        v-model="isUpdatePacModalOpen"
        width="500"
      >
        <UpdatePacModal
          :parametre="parametre"
          @close="isUpdatePacModalOpen = false"
          @updatedParametre="updatedParametrePac"
        />
      </v-dialog>
      <v-dialog
        v-if="isUpdateRestitutionNutritiveModalOpen"
        v-model="isUpdateRestitutionNutritiveModalOpen"
        width="500"
      >
        <UpdateRestitutionNutritiveModal
          :parametre="parametre"
          @close="isUpdateRestitutionNutritiveModalOpen = false"
          @updatedParametre="updatedParametreRestitutionNutritive"
        />
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import UpdatePacModal from './update-pac-modal.vue'
import UpdateRestitutionNutritiveModal from './update-restitution-nutritive-modal.vue'

export default {
  name: 'UpdateIndicateursNonChiffresModal',
  components: {AgrButton, UpdatePacModal, UpdateRestitutionNutritiveModal},
  props: {
    indicateursNonChiffres: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      erreur: null,
      isUpdatePacModalOpen: false,
      isUpdateRestitutionNutritiveModalOpen: false,
      parametre: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
      }
    }
  },

  computed: {
    indicateursNonChiffresRestitutionNutritive () {
      return this.indicateursNonChiffres.restitutionNutritive
    },
    indicateursNonChiffresPAC () {
      return this.indicateursNonChiffres.indicateurNonChiffrePAC
    }
  },

  methods: {
    onClose () {
      this.$emit('close')
    },
    closeModalNouveauParametre () {
      this.isUpdateParametreModalOpen = false
    },
    onOpenUpdateParametreModal (value) {
      this.parametre = this.indicateursNonChiffres
      if (value === 'PAC') {
        this.isUpdatePacModalOpen = true   
      } else {
        this.isUpdateRestitutionNutritiveModalOpen = true
      }
      
    },
    updatedParametrePac () {
      this.$emit('updatedParametre', this.indicateursNonChiffres.typeCulture.id)
      this.isUpdatePacModalOpen = false
    },
    updatedParametreRestitutionNutritive () {
      this.$emit('updatedParametre', this.indicateursNonChiffres.typeCulture.id)
      this.isUpdateRestitutionNutritiveModalOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.background {
  background: #EFF0E1;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
